var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectordb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 584 522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    /* Set everything to white */\n    * {\n      fill: #fff;\n      stroke: #fff;\n    }\n    .node {\n      fill: #fff;\n    }\n    .node-outline {\n      fill: #fff;\n      stroke: #fff;\n      stroke-width: 2;\n    }\n    .connector {\n      stroke: #fff;\n      stroke-width: 2;\n      stroke-linecap: round;\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "node",
    cx: 278,
    cy: 200,
    r: 46
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "node",
    cx: 395,
    cy: 325,
    r: 30
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "node",
    cx: 440.42,
    cy: 120.65,
    r: 30.59
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "node",
    cx: 131.42,
    cy: 87.65,
    r: 24.58
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "node",
    cx: 148.08,
    cy: 369.49,
    r: 27.96
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "node-outline",
    cx: 38,
    cy: 240,
    r: 30
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "node-outline",
    cx: 301.5,
    cy: 31.5,
    r: 23.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "node-outline",
    cx: 329.5,
    cy: 485.5,
    r: 28.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "node-outline",
    cx: 545,
    cy: 271,
    r: 31
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 171.19,
    y1: 341.94,
    x2: 247.19,
    y2: 244.35
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 314.79,
    y1: 239.52,
    x2: 366.76,
    y2: 299.58
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 329.85,
    y1: 176.15,
    x2: 411,
    y2: 137
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 235.14,
    y1: 167.15,
    x2: 158.19,
    y2: 106.21
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 55,
    y1: 210,
    x2: 112.11,
    y2: 113.9
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 55,
    y1: 264.72,
    x2: 119.83,
    y2: 347.25
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 176.13,
    y1: 391.99,
    x2: 294,
    y2: 471
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 350,
    y1: 457,
    x2: 384.81,
    y2: 361.61
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 431.1,
    y1: 313.13,
    x2: 514,
    y2: 287
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 529.17,
    y1: 244.35,
    x2: 469.49,
    y2: 146
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 323.89,
    y1: 38.64,
    x2: 411,
    y2: 95.7
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "connector",
    x1: 278,
    y1: 31,
    x2: 158.19,
    y2: 69.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectordb);
export default __webpack_public_path__ + "static/media/vectordb.92fcaf590d754fbfc95233c5ed34e9b0.svg";
export { ForwardRef as ReactComponent };